import {
  getClientArticlePayRules,
  getEndcustomerArticlePayRules,
  getEndcustomerArticlePayTypes
} from "API/swesum";
import { createContext, useContext, useEffect, useState } from "react";
import { PAYRULES_OPTIONS } from "utils/options/PAYRULES_OPTIONS";

const PayRulesContext = createContext(null);

export const PayRuleType = {
  CLIENT: "client",
  ENDCUSTOMER: "endcustomer",
};

export const PayRulesContextProvider = ({ children, type }) => {
  const [payRules, setPayRules] = useState([]);
  const [payTypes, setPayTypes] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchPayRulesAndType = async () => {
    setLoading(true);
    let rulesRes = [];
    let typesRes = [];
    switch (type) {
      case PayRuleType.CLIENT:
        rulesRes = await getClientArticlePayRules();
        break;
      case PayRuleType.ENDCUSTOMER:
        rulesRes = await getEndcustomerArticlePayRules();
        typesRes = await getEndcustomerArticlePayTypes();
        break;

      default:
        break;
    }

    setPayRules(rulesRes);
    setPayTypes(typesRes);
    setLoading(false);
  };

  useEffect(() => {
    fetchPayRulesAndType();
  }, []);

  return (
    <PayRulesContext.Provider
      value={{
        payRules,
        payTypes,
        loading,
      }}
    >
      {children}
    </PayRulesContext.Provider>
  );
};

export const usePayRules = () => useContext(PayRulesContext);
